import React, { useEffect, useState } from "react";
import RfmModalBase from "./RfmModalBase";

const DEFAULT_REASON = "Cierre manual desde POS";

export default function RfmCloseTableSessionModal({ open, onClose, hasOpenOrder, processing, onConfirm }) {
  const [reason, setReason] = useState(DEFAULT_REASON);

  useEffect(() => {
    if (open) setReason(DEFAULT_REASON);
  }, [open]);

  return (
    <RfmModalBase
      open={open}
      title="Cerrar sesión e-commerce"
      onClose={onClose}
      footer={
        <>
          <div className="ord-footer">
            <button className="ord-btn ord-btn-secondary" type="button" onClick={onClose}>
              Cancelar
            </button>
            <button className="ord-btn ord-btn-primary" type="button" disabled={processing}
              onClick={() => onConfirm?.(reason.trim() || DEFAULT_REASON)}>
              <i className="bi bi-x-circle" /> Cerrar sesión
            </button>
          </div>
        </>
      }
    >
      <div className="ord-scope">
        {hasOpenOrder ? (
          <div className="ord-confirm-note is-warning">
            <i className="bi bi-exclamation-triangle" />
            {/* <p>Esta mesa tiene una orden abierta. El backend decidirá si permite cerrar la sesión. ¿Deseas continuar?</p> */}

            <p>Esta mesa tiene una orden abierta.
              Al continuar, el sistema verificará si puedes cerrar la sesión. ¿Deseas continuar?</p>
          </div>
        ) : (
          <p className="ord-confirm-text">¿Deseas cerrar la sesión e-commerce de esta mesa?</p>
        )}

        <div className="ord-form-group">
          <label className="ord-form-label">Motivo del cierre (Si hay motivo puede justificarlo aquí)</label>
          <input
            className="ord-form-input"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder={DEFAULT_REASON}
          />
        </div>
      </div>
    </RfmModalBase>
  );
}
